export enum SubmitStatus {
    NotSent, Pending, Success, Failed, FailedIdInUse
}